import React from "react";
import PropTypes from "prop-types";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {Collector, ForEach} from "@morningtrain/react-resources";
import {useField} from "@morningtrain/react-fields";
import RepeaterItemsWrapper from "./RepeaterItemsWrapper";
import RepeaterSegment from "./RepeaterSegment";
import AddRepeaterItem from "./AddRepeaterItem";
import "./_repeater.scss";
import {CollectionContext} from "@morningtrain/react-resources";

function Repeater(props) {

    const field = useField({...props, defaultValue: observable.array()});

    const {id, label, name, value, wrap} = field;

    return wrap(() => (
        <Collector>
            <div className="form-element endless-field repeater-field-wrapper">
                <div className={'repeater-field-wrapper-header'}>
                    <div className={'repeater-field-wrapper-header-label'}>
                        <label htmlFor={id}>{label}</label>
                    </div>
                    <div className={'repeater-field-wrapper-header-actions'}>
                        <div className="form-button-wrap">
                            <AddRepeaterItem />
                        </div>
                    </div>
                </div>
                <RepeaterItemsWrapper items={value} name={name}>
                    <CollectionContext.Provider value={value} >
                        <ForEach>
                            <RepeaterSegment fieldName={name} itemHeader={props.itemHeader} extraHeaderActions={props.extraHeaderActions}>
                                {props.children}
                            </RepeaterSegment>
                        </ForEach>
                    </CollectionContext.Provider>
                </RepeaterItemsWrapper>
            </div>
        </Collector>
    ), true);
}

Repeater.defaultProps = {
    defaultValue: null,
    itemHeader: null,
    extraHeaderActions: null,
    addLabel: 'Tilføj række',
    removeLabel: 'Fjern',
    appendNew: true,
    displayOnly: false,
    draggable: true,
    collapsable: true,
    buttonClass: 'button small',
    removeConfirmMessage: 'Er du sikker på at du vil fjerne dette element?'
};

Repeater.propTypes = {
    draggable: PropTypes.bool,
    collapsable: PropTypes.bool,
};

export default observer(Repeater);
